// extracted by mini-css-extract-plugin
export default {"footerContainer":"kJ9st2NYlZkxgzxpmVG6","footerText":"M0gJpydvLAaAvZ1mmbdV"};